module.exports = __webpack_public_path__ + "static/media/Ni.f3576c30.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Ni.mp3
// module id = 50
// module chunks = 0